 
export class Forsoeg {
        public id: string;
        public value: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Forsoeg.ts